import {Inject, Injectable} from "@angular/core";
import {
    ActionService,
    collection,
    component,
    ConfigurationService,
    dateField,
    EntityData,
    field,
    JwtHttpClientService,
    ResourceModule
} from "@fedelta-pos/data-client";
import {AddressData} from "../customer-info/address.data";
import {PaymentAuthorisationType, PaymentType} from "../payment/payment";
import {MergedScheduleData} from "../menu/menu-entity.model";

export class OrderItemSchedulesData extends EntityData<OrderItemSchedulesData> {
    @field itemIdentifier: string;
    @collection() mergedSchedules: MergedScheduleData[];
}

export class BrowserInfoData extends EntityData<BrowserInfoData> {
    @field acceptHeader: string;
    @field colorDepth: number;
    @field javaEnabled: boolean;
    @field javaScriptEnabled: boolean;
    @field language: string;
    @field screenHeight: number;
    @field screenWidth: number;
    @field timeZoneOffset: number;
    @field userAgent: string;
}

export class PaymentAuthorisationData extends EntityData<PaymentAuthorisationData> {
    @field amount: number;
    @field paymentSurchargeAmount: number;
    @field tipAmount: number;
    @field token: string;
    @field paymentAuthorisationType: PaymentAuthorisationType = PaymentAuthorisationType.STRIPE_PAYMENT_METHOD;
    @field paymentType: PaymentType;
    @field paymentCardBrand: string;
    @field paymentCardCountry: string;
    @field paymentCardLast4: string;
    @field storePaymentDetails: boolean;
    @field payWithPoints: boolean;
    @field paymentIntentId: string;
    @field paymentCustomerId: string;
    @dateField paymentCustomerCreated: Date;

    /**
     * Browser info for 3DS
     */
    @field origin: string;
    @component browserInfo: BrowserInfoData;

    isThreeDS: boolean = false;
    payerPhone: string;
}

export class OrderPlacementData extends EntityData<OrderPlacementData> {
    @field requestId: string;
    @field appSessionId: string;
    @field scanId: string;
    @field orderToken: string;
    @field deliveryIdentifier: string;
    @field firstName: string;
    @field lastName: string;
    @field email: string;
    @field mobilePhone: string;
    @field nameTrusted: boolean;
    @field lastNameTrusted: boolean;
    @field emailTrusted: boolean;
    @field mobilePhoneTrusted: boolean;
    @field marketingOptIn: boolean;
    @field customerNotes: string;
    @component address: AddressData;
    @field deliveryInstructions: string;
    @field saveAddressForMember: boolean;
    @field appUserId: string;

    /**
     * Indicates the transfer target (group order) id currently 'owned' by this order.
     * Used to remove the transfer target.
     */
    @field orderTransferTargetId: string;

    @field checkAvailableQtys: boolean;

    @component paymentAuthorisation: PaymentAuthorisationData;
    @collection(OrderItemSchedulesData) orderItemSchedules: OrderItemSchedulesData[];
}

export enum OrderPlacementStatus {
    PENDING = <any>"PENDING",
    REJECTED = <any>"REJECTED",
    CANCELLED = <any>"CANCELLED",
    ACCEPTED = <any>"ACCEPTED"
}

// noinspection GrazieInspection
export class PlacedOrderData extends EntityData<PlacedOrderData> {
    @field requestId: string;
    @field receiptId: string;
    @field status: OrderPlacementStatus = OrderPlacementStatus.ACCEPTED;
    @field lookupCode: string;
    @field estimatedCompletionTime: string; // h:mm a, MMM d
    @field estimatedCompletionLocalDateTime: string; // yyyy-MM-ddTHH:mm:ss
    @dateField estimatedCompletionDateTime: Date;
    @dateField placedDateTime: Date;
    @field paymentCustomerId: string;
    @field emailKnown: boolean;
    @field mobilePhoneKnown: boolean;
    @field postCodeKnown: boolean;
    /**
     * App User id that was used when placing the order. The server can decide to use a different app user id that was sent when placing the order.
     */
    @field appUserId: string;
}

export class PlacedOrdersData extends EntityData<PlacedOrdersData> {
    @collection(PlacedOrderData) placedOrders: PlacedOrderData[];
}

@Injectable()
export class OrderPlacementService extends ActionService {
    constructor(http: JwtHttpClientService, configService: ConfigurationService, @Inject(ResourceModule.RESOURCE_NAMESPACE_KEY) nameSpace, @Inject(ResourceModule.ACTION_NAMES_KEY) actionNames) {
        console.log("--- OrderPlacementService");

        super(http, configService, nameSpace, actionNames, "web-order-placement");
    }
}



// WEBPACK FOOTER //
// ./src/app/order/order-placement.service.ts